import { ComponentPropsWithoutRef, ReactNode } from 'react';
import { LabelStrategy } from 'components/filter/filters-next/LabelStrategy';
import {
    transformNegationOperatorToReadable,
    transformRelationalResourceToReadable,
} from 'components/filter/filters-next/relational';
import { useCurrentFilter } from 'components/filter/filters-next/useCurrentFilter';
import { capitalize, identity } from 'lodash';
import { twJoin, twMerge } from 'tailwind-merge';

interface ReadableFilterValueProps extends ComponentPropsWithoutRef<'span'> {
    Label?: ReactNode;
}

const ReadableFilterValue = (props: ReadableFilterValueProps) => {
    const { children, className, Label, ...rest } = props;
    const filter = useCurrentFilter();
    const relationalKeyTransform = filter?.negationOperator ? identity : capitalize;

    if (!filter) {
        return <span>N/A</span>;
    }

    return (
        <span className={twMerge(className, 'flex items-center gap-1 text-gray-500')} {...rest}>
            {filter.relationalServerKey && (
                <span>
                    {capitalize(
                        filter.negationOperator
                            ? transformNegationOperatorToReadable(filter.negationOperator)
                            : '',
                    )}{' '}
                    {relationalKeyTransform(
                        transformRelationalResourceToReadable(filter.relationalServerKey),
                    )}{' '}
                    of
                </span>
            )}
            <span
                className={twJoin(filter.relationalServerKey && 'lowercase', 'flex items-center')}
            >
                {Label ?? (
                    <LabelStrategy
                        strategy={filter.serverKey}
                        relationalServerKey={filter.relationalServerKey}
                    />
                )}
                {children && (
                    <span className={'flex items-center gap-1'}>
                        <span>:</span>
                        <span className={'text-blue-500'}>{children}</span>
                    </span>
                )}
            </span>
        </span>
    );
};

export { ReadableFilterValue };
export type { ReadableFilterValueProps };
